var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 24px / id"
  }, /*#__PURE__*/React.createElement("path", {
    id: "id",
    d: "M12.1645 24H9.93419L12.1645 17.4873H8.10603L5.91225 24H3.64534L5.87569 17.4873H2L2.62157 15.5802H6.53382L8.94698 8.41979H4.99817L5.58318 6.54873H9.60512L11.7989 0H14.0658L11.872 6.54873H15.894L18.0878 0H20.3181L18.0878 6.54873H22L21.4516 8.41979H17.4662L15.0165 15.5802H19.075L18.4899 17.4873H14.3583L12.1645 24ZM12.7861 15.5802L15.1993 8.41979H11.1773L8.76417 15.5802H12.7861Z",
    fill: "#5E5F66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.4ce8377da41e7aa2186875fc8b93d28f.svg";
export { ForwardRef as ReactComponent };